import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { clsx } from 'clsx';
import { HomeVM } from '../home.viewModel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { IconButton } from '@design-system/components/button/iconButton';
import { faShareNodes } from '@fortawesome/pro-light-svg-icons';
import { Row } from '@design-system/components/grid/grid';
import { LinksModal } from '@client/new/pages/collections/components/linksModal';
const howToUseURL =
  'https://help.playbookapp.io/en/articles/10610719-use-sharable-links-to-promote-your-app-channel-products';
export const CreatorLinks = ({
  dispatch,
  linksModal,
}: Pick<HomeVM, 'dispatch' | 'linksModal'>) => {
  if (!linksModal.showLinks) return null;

  return (
    <div className="bg-white rounded-[10px] p-5 flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <Typography variant="title">
          Get sharable links & start selling
        </Typography>
        <Row className="gap-4">
          <a
            className={clsx(
              'flex gap-2 items-center',
              sprinkles({ color: 'P-80' }),
            )}
            href={howToUseURL}
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faQuestionCircle} />
            <Typography>How to market your app</Typography>
          </a>
          <IconButton
            icon={faShareNodes}
            variant="filled"
            color="primaryTonal"
            onClick={() => dispatch('openLinksModal')}
          >
            Share
          </IconButton>
        </Row>
      </div>

      <Typography variant="bodyLarge" fontWeight="normal">
        Use a sharable link to promote your app channel & products to your
        audience
      </Typography>

      <LinksModal
        isOpen={linksModal.isOpen}
        onClose={() => dispatch('closeLinksModal')}
        data={{
          links: linksModal.links,
          afterDesc: linksModal.afterDesc,
        }}
      />
    </div>
  );
};
